import { Injectable, inject } from "@angular/core";

import { AnalyticsService, EVENT_UAEVENT } from "@hermes/fragments/analytics";

const MODULE_PODCAST = "Module_Podcast";
const MODULE_PODCAST_SUBSCRIPTION = "Module_Podcast_Subscription";

@Injectable()
export class PodcastAnalyticsService {
    private analyticsService = inject(AnalyticsService);

    public sendPauseEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: "Pause",
            eventlabel: eventLabelPodcast,
        });
    }

    public sendFirstPlayEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: "FirstPlay",
            eventlabel: eventLabelPodcast,
        });
    }
    public sendNewPlayEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: "NewPlay",
            eventlabel: eventLabelPodcast,
        });
    }

    public sendRewindEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: "rw15",
            eventlabel: eventLabelPodcast,
        });
    }

    public sendForwardEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: "fw15",
            eventlabel: eventLabelPodcast,
        });
    }

    public sendMuteAudioEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: "mute",
            eventlabel: eventLabelPodcast,
        });
    }

    public sendEndOfPodcastEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: "Stop",
            eventlabel: eventLabelPodcast,
        });
    }

    public sendPercentageProgressPodcastEvent(
        eventLabelPodcast: string,
        percentageProgress: string,
    ): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST,
            eventaction: percentageProgress,
            eventlabel: eventLabelPodcast,
        });
    }

    public sendSubscribeEvent(eventLabelPodcast: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST_SUBSCRIPTION,
            eventaction: "Subscribe",
            eventlabel: eventLabelPodcast,
        });
    }

    public sendSubscribePlatformEvent(
        platformName: string,
        eventLabelPodcast: string,
    ): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: MODULE_PODCAST_SUBSCRIPTION,
            eventaction: platformName,
            eventlabel: eventLabelPodcast,
        });
    }
}
